// extracted by mini-css-extract-plugin
module.exports = {"largeButton":"ActionButton_largeButton__2Hcj8"};